import React, { useEffect } from 'react';
import { Box, Button, Dialog, Typography } from 'src/components';
import Alert from 'src/components/Alert';
import DialogActions from 'src/components/DialogActions';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ParametreGrupEnum from 'src/enums/ParametreGrupEnum';
import { translate } from 'src/i18n/tHelper';
import { useAppDispatch, useAppSelector } from 'src/store';
import { helper } from 'src/utils/helper';
import { HastaKaraListeSlice } from 'src/store/Slices/HastaUyariListesi/HastaKaraListeSlice';
import { useLazyHastaKaraListeUyariSorgulaQuery } from 'src/services/HastaUyariListesi/HastaKaraListeApi';

const translatePath = "pages|hastaUyariListesi";
const HastaKaraListeGenelUyari = (): JSX.Element => {
    const state = useAppSelector(s => s.hastaKaraListe);
    const parameters = useAppSelector(s => s.parameters.data);
    const kimlikState = useAppSelector(s => s.kimlik);
    const dispatch = useAppDispatch();

    const [hastaKaraListSorgula, hastaKaraListSorgulaState] = useLazyHastaKaraListeUyariSorgulaQuery();

    useEffect(() => {
        if (kimlikState.activeRow?.id > 0) {
            let tcNo = "";
            let passNo = "";
            let dosNo = "";
            if (kimlikState.activeRow?.id > 0)
                dosNo = helper.objectToString(kimlikState.activeRow.id);
            if (!helper.stringIsNullOrEmpty(kimlikState.activeRow.kimlikNo))
                tcNo = kimlikState.activeRow.kimlikNo;
            if (!helper.stringIsNullOrEmpty(kimlikState.activeRow.pasaportNo))
                passNo = kimlikState.activeRow.pasaportNo;
            hastaKaraListSorgula({ tcNo: tcNo, passNo: passNo, dosNo: dosNo }).unwrap().then((v) => {
                if (v?.id > 0)
                    dispatch(HastaKaraListeSlice.actions.setUyariPopupOpen(true));
            });
        }
    }, [kimlikState.activeRow]);

    const handlerSave = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(HastaKaraListeSlice.actions.setUyariPopupOpen(false));
    };
    const handlerClose = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(HastaKaraListeSlice.actions.setUyariPopupOpen(false));
    };

    const InfoRow = ({ label, value }) => (
        <Box sx={{ display: 'flex', mb: 0.5, fontFamily: 'monospace', alignItems: 'center' }}>
            <Typography sx={{ width: '160px', fontSize: '12px', lineHeight: 1.2 }}>
                {label}
            </Typography>
            <Typography sx={{ fontSize: '12px', mx: 0.5 }}>:</Typography>
            <Typography sx={{ fontSize: '12px', fontWeight: 'bold', lineHeight: 1.2 }}>
                {value}
            </Typography>
        </Box>
    );

    return (
        <Dialog fullWidth open={state.uyariPopupOpen} maxWidth="xs">
            <DialogTitle
                sx={{
                    background: 'linear-gradient(to bottom, #6495ED, #4169E1)',
                    color: 'white',
                    py: 0.5,
                    px: 1.5,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '12px'
                }}
                icons={<AssignmentIcon sx={{ fontSize: 16 }} />}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {hastaKaraListSorgulaState?.data?.fkIslem === 1 ? (
                        <>{translate(translatePath, "Onay Ekranı...")}</>
                    ) : (
                        <>{translate(translatePath, "Mesajınız var...")}</>
                    )}
                </Box>
            </DialogTitle>
            <Alert
                severity="warning"
                icon={false}
                sx={{
                    background: 'linear-gradient(to bottom, #b8d4f1, #8cb3db)',
                    borderRadius: 0,
                    border: 'none',
                    borderBottom: '2px solid #4169E1',
                    color: '#000080',
                    fontWeight: 'bold',
                    justifyContent: 'center',
                    py: 0.8,
                    fontSize: '13px',
                    '& .MuiAlert-message': {
                        width: '100%',
                        textAlign: 'center'
                    }
                }}
            >
                {translate(translatePath, "DİKKAT ! HASTA İÇİN UYARI VAR")}
            </Alert>
            <DialogContent sx={{ backgroundColor: '#fffbcc', py: 1.5, px: 2 }}>
                <Box sx={{ mb: 1 }}>
                    <InfoRow label={translate(translatePath, "Hasta TC. Kimlik No")} value={hastaKaraListSorgulaState.data?.tckimlikno} />
                    {!helper.stringIsNullOrEmpty(hastaKaraListSorgulaState.data?.pasaportno) && (
                        <InfoRow label={translate(translatePath, "Hasta Pasaport No")} value={hastaKaraListSorgulaState.data?.pasaportno} />
                    )}
                    <InfoRow label={translate(translatePath, "Hasta Adı Soyadı")} value={`${hastaKaraListSorgulaState.data?.ad} ${hastaKaraListSorgulaState.data?.soyad}`} />
                    <InfoRow label={translate(translatePath, "Hasta Baba Adı")} value={hastaKaraListSorgulaState.data?.babaad} />
                </Box>
                <Box sx={{ mb: 1, mt: 1.5 }}>
                    <InfoRow label={translate(translatePath, "Uyarı Grubu")} value={parameters.find((f) => f.grupId === ParametreGrupEnum.HastaUyariGrubu && f.key === hastaKaraListSorgulaState.data?.fkGrup)?.value || translate(translatePath, "Uyarı Grubu Seçilmemiş")} />
                </Box>
                <Box sx={{ mb: 1, mt: 1.5 }}>
                    <InfoRow label={translate(translatePath, "Açıklama")} value={hastaKaraListSorgulaState.data?.aciklama} />
                </Box>
                <Box sx={{ mt: 1.5, pt: 1, borderTop: '1px solid #ccc' }}>
                    <Typography sx={{ fontFamily: 'monospace', fontSize: '12px', mb: 0.5, lineHeight: 1.3 }}>
                        {hastaKaraListSorgulaState.data?.fkIslem === 1 ? (
                            <>{translate(translatePath, "İşleme Devam Edecek misiniz ?")}</>
                        ) : (
                            <>{translate(translatePath, "İşleme Devam Edemezsiniz !...")}</>
                        )}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{
                backgroundColor: '#d4d0c8',
                borderTop: '2px solid #fff',
                px: 1.5,
                py: 1,
                display: 'flex',
                justifyContent: hastaKaraListSorgulaState.data?.fkIslem === 1 ? 'space-between' : 'flex-end'
            }}>
                {hastaKaraListSorgulaState.data?.fkIslem === 1 && (
                    <Button
                        customType="accept"
                        onClick={handlerSave}
                        sx={{
                            backgroundColor: '#d4d0c8',
                            color: 'black',
                            borderRadius: 0,
                            border: '2px outset #d4d0c8',
                            textTransform: 'none',
                            boxShadow: 'none',
                            fontSize: '12px',
                            px: 2,
                            py: 0.5,
                            minWidth: 'auto',
                            width: 'auto',
                            '&:hover': {
                                backgroundColor: '#e4e0d8',
                                boxShadow: 'none'
                            },
                            '&:active': {
                                borderStyle: 'inset'
                            }
                        }}
                    >{translate(translatePath, "Tamam")}</Button>
                )}
                <Button
                    variant="contained"
                    customType="close"
                    onClick={handlerClose}
                    sx={{
                        backgroundColor: '#d4d0c8',
                        color: 'black',
                        borderRadius: 0,
                        border: '2px outset #d4d0c8',
                        textTransform: 'none',
                        boxShadow: 'none',
                        fontSize: '12px',
                        px: 2,
                        py: 0.5,
                        minWidth: 'auto',
                        width: 'auto',
                        '&:hover': {
                            backgroundColor: '#e4e0d8',
                            boxShadow: 'none'
                        },
                        '&:active': {
                            borderStyle: 'inset'
                        }
                    }}
                />
            </DialogActions>
        </Dialog>
    );
};

export default HastaKaraListeGenelUyari;